import { createSlice } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../@types/GerenciadorPrecos';
import { RootState } from '../../@types/RootState';

export type GerenciadorPrecosOptimizationSummaryProps = {
  modalIsOpen: boolean;
  rowData: GerenciadorPrecos.RowData | null | { optimizationId: string };
};

const initialState: GerenciadorPrecosOptimizationSummaryProps = {
  modalIsOpen: false,
  rowData: null,
};

const slice = createSlice({
  name: '/ipa/gerenciador-de-precos/otimization-price-edited',
  initialState,
  reducers: {
    handleModalState(
      state,
      {
        payload,
      }: {
        payload: {
          modalIsOpen: boolean;
        };
      },
    ) {
      state.modalIsOpen = payload.modalIsOpen;
    },
    setOptimizationSummaryRowData(state, { payload }: { payload: GerenciadorPrecos.RowData }) {
      state.rowData = payload;
      if (payload.priceStatus === 'OTIMIZADO') {
        state.modalIsOpen = true;
      }
    },
    setOptimizationSummaryPriceList(state, { payload }: { payload: { id: string } }) {
      state.rowData = {
        optimizationId: payload.id,
      };
      state.modalIsOpen = true;
    },
    resetOptimizationPrices() {
      return initialState;
    },
  },
});

const selectorModalOptimizationSummary = (state: RootState) => {
  return state.gerenciadorPrecosReducer.optimizationSummary;
};

export const { resetOptimizationPrices, handleModalState, setOptimizationSummaryRowData, setOptimizationSummaryPriceList } = slice.actions;

export { selectorModalOptimizationSummary };

export default slice.reducer;
